import React, { useState } from "react";
import TicketList from "./AssignedTicketList";
import MyTicketSearch from "./MyTicketSearch";

const AssignedTickets = () => {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (params) => {
    setSearchParams(params);
  };

  return (
    <>
      <div>
        <MyTicketSearch onSearch={handleSearch} />
        <section className="bg-white shadow-md p-6 rounded-lg mb-6">
          <h2 className="text-gray-700 text-lg font-semibold mb-4">Ticket List</h2>
          <div className="overflow-x-auto">
            <TicketList searchParams={searchParams} />
          </div>
        </section>
      </div>
    </>
  );
}
export default AssignedTickets;